import { render, staticRenderFns } from "./ServiceStaff.vue?vue&type=template&id=2768a872"
import script from "./ServiceStaff.vue?vue&type=script&lang=js"
export * from "./ServiceStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports